'use client';

import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const SpecTable = ({ specs }) => {
  const [rows, setRows] = useState(5);
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {specs.slice(0, rows).map((spec, index) => (
            <TableRow key={index}>
              <TableCell>{spec.name}</TableCell>
              <TableCell>{spec.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {rows < specs.length && (
        <Button
          variant="text"
          size="large"
          fullWidth
          endIcon={<KeyboardArrowDownIcon />}
          onClick={() => setRows(specs.length)}
        >
          View All
        </Button>
      )}
    </TableContainer>
  );
};
export default SpecTable;
